import { Link, Button, Card } from "@endya-conformite/ui-kit";
import ArrowRight from "@endya-conformite/ui-kit/src/assets/icons/arrow-right.svg?react";
import { PrismicDocument } from "@prismicio/client";
import { PrismicImage, PrismicText } from "@prismicio/react";
import classNames from "classnames";
import { CmsVoirTout } from "../CmsVoirTout";
import styles from "./Actualite.module.scss";
import { PrismicActualite } from "./useActualite";

type ActualiteListProps = {
  actualites: PrismicDocument<PrismicActualite, string, string>[];
  variant?: "bento" | "list";
};
export function ActualiteList({
  actualites,
  variant = "list",
}: ActualiteListProps) {
  return (
    <div
      className={classNames(styles.actualiteList, {
        [styles[`layout_${variant}`]]: variant,
      })}
    >
      {actualites.map((doc, index) => {
        if (index >= actualites.length) return null;
        const isBig = variant === "bento" && index === 0;

        return (
          <Card
            key={doc.id}
            className={classNames(styles.actualite, {
              [styles.big]: isBig,
            })}
          >
            <PrismicImage
              field={doc.data.image_preview}
              className={styles.image}
            />
            <div className={styles.content}>
              <div>
                <p className={styles.title}>
                  <PrismicText field={doc.data.description_preview} />
                </p>
              </div>
              <Link to={`/actualites/${doc.uid ?? ""}`}>
                <Button variant="outline" icon={<ArrowRight />}>
                  Lire l&apos;article
                </Button>
              </Link>
            </div>
          </Card>
        );
      })}

      {variant === "bento" && (
        <div className={styles.footerWrapper}>
          <CmsVoirTout to="/actualites/" />
        </div>
      )}
    </div>
  );
}
